/**
 * Stringifies an error object.
 *
 * This function converts an error object into a string representation. It
 * handles errors that are instances of Error, as well as other types of
 * error-like objects.
 */
// eslint-disable-next-line complexity
export function stringifyError(error: unknown): string {
  if (error instanceof Error) {
    let result = `${error.name}: ${error.message}`;
    if (error.stack) {
      result += `\n${error.stack}`;
    }

    // Check for additional properties (extensions)
    for (const key in error) {
      if (
        key in error &&
        key !== "name" &&
        key !== "message" &&
        key !== "stack"
      ) {
        try {
          // Attempt to serialize in case of nested objects
          result += `\n${key}: ${JSON.stringify(
            // Library code; TS knows `Error` has finite properties; but this could be an object that extends Error, and has more properties, so we have to expand our type here.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (error as unknown as Record<string, unknown>)[key]
          )}`;
        } catch (e) {
          result += `\n${key}: [Unable to serialize]`; // Handle cases where serialization fails (e.g., circular references)
        }
      }
    }

    return result;
  } else if (typeof error === "string") {
    return error;
  } else if (error && typeof error === "object" && "toString" in error) {
    return error.toString();
  } else {
    return "An unknown error occurred.";
  }
}
